import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { CATEGORIES, byCategory } from "@/data/catalog";

export const MegaMenu = ({ catId, onClose }) => {
  const { t } = useTranslation();
  const cat = CATEGORIES.find((c) => c.id === catId);
  if (!cat) return null;
  const products = byCategory(catId);
  const featured = products.filter((p) => p.tag === "loved" || p.tag === "new").slice(0, 3);
  const pick = featured.length >= 3 ? featured : [...featured, ...products.filter((p) => !featured.includes(p)).slice(0, 3 - featured.length)];
  const half = Math.ceil(cat.subs.length / 2);
  const cols = [cat.subs.slice(0, half), cat.subs.slice(half)];

  return (
    <div data-testid={`mega-menu-${catId}`} className="nv-fade-up absolute inset-x-0 top-full z-40 border-t border-black/10 bg-white shadow-[0_40px_80px_-30px_rgba(0,0,0,0.35)]">
      <div className="nv-container grid grid-cols-12 gap-8 py-8">
        <div className="col-span-3">
          <p className="nv-eyebrow">{t(`nav.${catId}`)}</p>
          <h3 className="mt-2 font-display text-2xl font-bold">{t(`catDesc.${catId}`)}</h3>
          <Link to={`/c/${catId}`} onClick={onClose} data-testid={`mega-view-all-${catId}`} className="nv-btn-lime mt-6 !px-5 !py-2.5 text-xs">
            {t("nav.viewAll")} <ArrowRight size={14} />
          </Link>
          <p className="mt-4 text-xs text-black/50">{products.length} {t("home.products")}</p>
        </div>
        {cols.map((col, i) => (
          <ul key={i} className="col-span-2 space-y-1">
            {col.map((s) => (
              <li key={s}>
                <Link to={`/c/${catId}?sub=${s}`} onClick={onClose} data-testid={`mega-sub-${s}`} className="block rounded-lg px-3 py-2 text-sm font-medium text-black/75 transition-colors hover:bg-[#c6ff00] hover:text-black">
                  {t(`subs.${s}`)}
                </Link>
              </li>
            ))}
          </ul>
        ))}
        <div className="col-span-5 grid grid-cols-3 gap-3">
          {pick.map((p) => (
            <Link key={p.code} to={`/p/${p.code}`} onClick={onClose} className="group rounded-xl bg-[#f6f7f2] p-3 transition-colors hover:bg-black hover:text-white">
              <div className="aspect-square overflow-hidden rounded-lg bg-white">
                <img src={p.img} alt={p.name} className="nv-card-img h-full w-full object-contain p-2" />
              </div>
              <p className="mt-2 text-[10px] font-bold uppercase tracking-wider opacity-60">{p.brand}</p>
              <p className="line-clamp-2 text-xs font-semibold">{p.name}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
